// Human-readable Stripe payout schedule text, e.g.
// "Automatic - Weekly on Monday (2-day delay)", or "Manual" for manual payouts.
// $t must be the component's i18n translate function (`this.$t`), passed in
// so this stays a plain, component-agnostic helper.
export function formatPayoutSchedule(schedule, $t) {
  if (!schedule) {
    return "";
  }

  if (schedule.interval === "manual") {
    return $t("gateways.payout_schedule_manual", "Manual");
  }

  const delaySuffix = schedule.delay_days
    ? ` (${$t("gateways.payout_schedule_delay", `${schedule.delay_days}-day delay`, {
        days: schedule.delay_days,
      })})`
    : "";

  let intervalText;
  switch (schedule.interval) {
    case "daily":
      intervalText = $t("gateways.payout_schedule_daily", "Daily");
      break;
    case "weekly": {
      const day = schedule.weekly_anchor
        ? schedule.weekly_anchor.charAt(0).toUpperCase() + schedule.weekly_anchor.slice(1)
        : "";
      intervalText = $t("gateways.payout_schedule_weekly", `Weekly on ${day}`, { day });
      break;
    }
    case "monthly":
      intervalText = $t(
        "gateways.payout_schedule_monthly",
        `Monthly on day ${schedule.monthly_anchor}`,
        { day: schedule.monthly_anchor }
      );
      break;
    default:
      intervalText = schedule.interval;
  }

  const automaticPrefix = $t("gateways.payout_schedule_automatic_prefix", "Automatic");
  return `${automaticPrefix} - ${intervalText}${delaySuffix}`;
}
